import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
// Mirrors backend DEFAULT_SITE_CONTENT.flexfuel_offer — first paint only, replaced by /api/flexfuel-offer.
const DEFAULT_CFG = { enabled: true, offer_price: 306, regular_price: 360, end_date: "2026-12-31" };
const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

const computeOffer = (cfg) => {
  const today = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Paris" });
  const { offer_price: o, regular_price: r, end_date: end } = cfg;
  const active = cfg.enabled && o < r && (!end || today <= end);
  if (!active) return { active, price: r, end_date: end, label: `${r} € TTC`, label_short: `${r}€` };
  const [, m, d] = end ? end.split("-").map(Number) : [];
  const until = end ? ` jusqu'au ${d === 1 ? "1er" : d} ${MONTHS[m - 1]}` : "";
  const pct = Math.round((1 - o / r) * 100);
  return { active, price: o, end_date: end, label: `${o} € TTC au lieu de ${r} € TTC (−${pct} %${until})`, label_short: `${o}€` };
};

let offerPromise = null;
const fetchOffer = () => {
  if (!offerPromise) offerPromise = axios.get(`${API}/api/flexfuel-offer`).then((r) => r.data).catch(() => null);
  return offerPromise;
};

export const resolveOffer = (str, offer) =>
  typeof str === "string" ? str.replace(/\{prix_flexfuel_court\}/g, offer.label_short).replace(/\{prix_flexfuel\}/g, offer.label) : str;

export const useFlexfuelOffer = () => {
  const [offer, setOffer] = useState(() => computeOffer(DEFAULT_CFG));
  useEffect(() => { fetchOffer().then((d) => d && setOffer(d)); }, []);
  return offer;
};
